export default __webpack_public_path__ + "static/media/instagram.99366fe2.svg";